import { render, staticRenderFns } from "./designer.vue?vue&type=template&id=7153ed4e&"
import script from "./designer.vue?vue&type=script&lang=js&"
export * from "./designer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports